import { colors } from '@mui/material';
import { lighten } from '@mui/material/styles';
// import {ezColors} from './colors'
//
//
// declare module '@mui/material/styles' {
//     interface Palette {
//         evaluation: {
//             unexpected: PaletteColor
//             accurate: PaletteColor
//             early: PaletteColor
//             late: PaletteColor
//             missed: PaletteColor
//             skipped: PaletteColor
//         }
//         sticking: {
//             left: PaletteColor
//             right: PaletteColor
//         }
//         level: {
//             beginner: PaletteColor
//             intermediate: PaletteColor
//             advanced: PaletteColor
//             expert: PaletteColor
//         }
//
//         ui: {
//             appheader: PaletteColor
//         }
//     }
//
//     interface PaletteOptions {
//         evaluation: {
//             unexpected: PaletteColor
//             accurate: PaletteColor
//             early: PaletteColor
//             late: PaletteColor
//             missed: PaletteColor
//             skipped: PaletteColor
//         }
//         sticking: {
//             left: PaletteColor
//             right: PaletteColor
//         }
//         level: {
//             beginner: PaletteColor
//             intermediate: PaletteColor
//             advanced: PaletteColor
//             expert: PaletteColor
//         }
//
//         ui: {
//             appheader: PaletteColor
//         }
//     }
// }
const ezColors = {
    white: colors.common.white,
    amber: colors.amber[500],
    deepOrange: colors.deepOrange[400],
    lightBlue: colors.lightBlue[500],
    indigo: colors.indigo[400],
    green: colors.green[500],
    teal: colors.teal['A400'],
    pink: colors.pink[500],
    red: colors.red[500],
    black: colors.common.black
};
export const lightPaletteOptions = (theme) => {
    const augmentColor = (color) => theme.palette.augmentColor({ color: { main: color } });
    return {
        mode: 'light',
        primary: {
            main: colors.lightBlue[500],
            light: colors.lightBlue[300],
            dark: colors.lightBlue[700],
            contrastText: colors.common.white,
        },
        warning: {
            main: colors.amber['A400'],
        },
        background: {
            default: colors.common.white,
        },
        text: {
            primary: colors.blueGrey[800]
        },
        evaluation: {
            missed: augmentColor(colors.red[500]),
            unexpected: augmentColor(colors.pink[500]),
            accurate: augmentColor(colors.teal['A400']),
            early: augmentColor(colors.pink[800]),
            late: augmentColor(colors.lightBlue[800]),
            skipped: augmentColor(colors.grey[500])
        },
        sticking: {
            left: augmentColor(colors.pink[600]),
            right: augmentColor(colors.lightBlue[600])
        },
        level: {
            beginner: {
                dark: colors.lightBlue[800],
                main: colors.lightBlue[300],
                light: colors.lightBlue[100],
                contrastText: colors.lightBlue[900],
            },
            intermediate: {
                dark: colors.teal[600],
                main: colors.teal[300],
                light: colors.green[50],
                contrastText: colors.teal[600],
            },
            advanced: {
                dark: colors.amber[800],
                main: colors.deepOrange[300],
                light: colors.amber[100],
                contrastText: colors.amber[800],
            },
            expert: {
                dark: colors.deepOrange[600],
                main: colors.deepOrange[300],
                light: colors.deepOrange[100],
                contrastText: colors.deepOrange[600],
            }
        },
        ui: {
            appheader: augmentColor(colors.lightBlue[900]),
        }
    };
};
export const darkPaletteOptions = (theme) => {
    const augmentColor = (color) => theme.palette.augmentColor({ color: { main: color } });
    return {
        mode: 'dark',
        primary: augmentColor(colors.teal['A400']),
        secondary: augmentColor(colors.grey[400]),
        background: {
            default: lighten(colors.grey[900], 0.1),
            paper: colors.grey[800],
        },
        text: {
            primary: colors.common.white,
            secondary: colors.grey[500],
            disabled: colors.grey[500],
        },
        divider: colors.grey[700],
        evaluation: {
            missed: augmentColor(colors.red[500]),
            unexpected: augmentColor(colors.pink[500]),
            accurate: augmentColor(colors.teal['A400']),
            early: augmentColor(colors.amber[400]),
            late: augmentColor(colors.lightBlue[500]),
            skipped: augmentColor(colors.grey[500])
        },
        sticking: {
            left: augmentColor(colors.pink[600]),
            right: augmentColor(colors.lightBlue[600])
        },
        level: {
            beginner: augmentColor(colors.green[500]),
            intermediate: augmentColor(colors.lightBlue[500]),
            advanced: augmentColor(colors.pink[500]),
            expert: augmentColor(colors.deepOrange[400])
        },
        ui: {
            appheader: augmentColor(colors.lightBlue[900])
        }
    };
};
//# sourceMappingURL=palette.js.map